import React from "react";

function Header() {
  return (
    <header>
      <h1>KeepMate</h1>
      <p>Samip Poudel © 2020</p>
    </header>
  );
}

export default Header;
